import { useEffect, useMemo, useState } from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';

import { selectAvailableCategoriesEntity } from '../../../redux/healthboard/patientPortal/selectors';
import { actions as availableCategoriesActions } from '../../../redux/healthboard/patientPortal/available-categories';
import { TABS_PATIENT_PORTAL } from '../constants';

const {
  MEDICATIONS,
  VITALS_AND_ACTIVITY,
  ALLERGIES,
  LAB_TEST_RESULT,
  CONDITIONS,
  IMMUNIZATIONS,
  FAMILY_HISTORY,
  ENCOUNTERS,
  SOCIAL_HISTORY,
  HEALTH_RECORD,
  ACTIVITY_LOG,
  PROCEDURES,
} = TABS_PATIENT_PORTAL;

const IMPLEMENTED_TABS = [
  MEDICATIONS,
  ALLERGIES,
  LAB_TEST_RESULT,
  CONDITIONS,
  IMMUNIZATIONS,
  FAMILY_HISTORY,
  ENCOUNTERS,
  SOCIAL_HISTORY,
  HEALTH_RECORD,
  ACTIVITY_LOG,
  PROCEDURES,
  VITALS_AND_ACTIVITY,
];

export function useTabs({ userId, withVitals, isProvider, deepLinkTab }) {
  const [activeTab, setActiveTab] = useState();
  const availableCategories = useSelector(selectAvailableCategoriesEntity);
  const firstCategory = availableCategories[0] || {};
  const firstCategoryType = get(availableCategories[0], 'categoryType', '');

  useEffect(() => {
    setActiveTab(deepLinkTab || firstCategoryType);
  }, [userId, deepLinkTab, firstCategoryType]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isProvider) {
      dispatch(availableCategoriesActions.send({ userId }));
    }
  }, [userId, isProvider]);

  const activeCategory = useMemo(
    () =>
      availableCategories.find(category => category.categoryType === activeTab),
    [availableCategories, activeTab],
  );

  const tabs = useMemo(() => {
    const baseTabs = withVitals
      ? availableCategories.filter(({ categoryType }) =>
          IMPLEMENTED_TABS.includes(categoryType),
        )
      : availableCategories.filter(
          ({ categoryType }) =>
            categoryType !== VITALS_AND_ACTIVITY &&
            IMPLEMENTED_TABS.includes(categoryType),
        );
    return baseTabs.map(({ categoryType, id, title }) => ({
      label: `patient.portal.${categoryType}`,
      id,
      tab: categoryType,
      title,
    }));
  }, [availableCategories, withVitals]);

  return {
    availableCategories,
    activeCategory,
    firstCategory,
    setActiveTab,
    activeTab,
    tabs,
  };
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/useTabsData.js